import { render, staticRenderFns } from "./NewAccountSetting.vue?vue&type=template&id=6573aee6&"
import script from "./NewAccountSetting.vue?vue&type=script&lang=js&"
export * from "./NewAccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports